import { ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';

export const ProductCard = ({ product, onAddToCart }) => {
  const hasDiscount = product.discount_percentage > 0;
  const finalPrice = hasDiscount
    ? product.price * (1 - product.discount_percentage / 100)
    : product.price;

  return (
    <div className="group relative bg-white border border-border/50 rounded-xl overflow-hidden hover:shadow-xl hover:border-primary/20 transition-all duration-300" data-testid={`product-card-${product.id}`}>
      {hasDiscount && (
        <span
          className="absolute top-3 left-3 z-10 bg-accent text-accent-foreground text-xs font-bold px-3 py-1 rounded-full shadow-lg"
          data-testid={`product-discount-${product.id}`}
        >
          -{product.discount_percentage}%
        </span>
      )}
      {product.is_featured && (
        <span className="absolute top-3 right-3 z-10 bg-primary text-primary-foreground text-xs font-bold px-3 py-1 rounded-full shadow-lg">
          Vedette
        </span>
      )}

      <Link to={`/produits/${product.id}`}>
        <div className="aspect-square overflow-hidden bg-muted">
          <img
            src={product.image_url}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            data-testid={`product-image-${product.id}`}
          />
        </div>
      </Link>
      
      <div className="p-6">
        <div className="mb-2 flex items-center justify-between">
          <span className="text-xs font-mono tracking-wide uppercase text-muted-foreground" data-testid={`product-category-${product.id}`}>
            {product.category}
          </span>
          {product.brand && (
            <span className="text-xs text-muted-foreground">{product.brand}</span>
          )}
        </div>
        
        <Link to={`/produits/${product.id}`}>
          <h3 className="font-heading font-semibold text-lg mb-2 text-secondary group-hover:text-primary transition-colors" data-testid={`product-name-${product.id}`}>
            {product.name}
          </h3>
        </Link>
        
        <p className="text-sm text-muted-foreground mb-4 line-clamp-2" data-testid={`product-description-${product.id}`}>
          {product.description}
        </p>
        
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-2xl font-bold text-primary" data-testid={`product-price-${product.id}`}>
              {finalPrice.toFixed(2)} DH
            </span>
            {hasDiscount && (
              <span className="text-sm text-muted-foreground line-through">
                {product.price.toFixed(2)} DH
              </span>
            )}
          </div>
          
          <button
            onClick={(e) => {
              e.preventDefault();
              onAddToCart({ ...product, price: finalPrice });
            }}
            className="bg-accent text-accent-foreground hover:bg-accent/90 h-10 w-10 rounded-full font-medium transition-all hover:scale-105 active:scale-95 shadow-lg shadow-accent/20 flex items-center justify-center"
            data-testid={`add-to-cart-btn-${product.id}`}
          >
            <ShoppingCart className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};
